var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#2D3136"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5703 28.4852C27.0857 29.0006 27.9405 29.0006 28.4559 28.4852C28.9713 27.9698 28.9713 27.115 28.4559 26.5996L21.8563 20L28.4559 13.4004C28.9713 12.885 28.9713 12.0302 28.4559 11.5148C27.9405 10.9994 27.0857 10.9994 26.5703 11.5148L19.9707 18.1144L13.371 11.5147C12.8556 10.9993 12.0007 10.9993 11.4853 11.5147C10.9699 12.0301 10.9699 12.8849 11.4853 13.4003L18.0851 20L11.4853 26.5997C10.9699 27.1151 10.9699 27.9699 11.4853 28.4853C12.0007 29.0007 12.8556 29.0007 13.371 28.4853L19.9707 21.8856L26.5703 28.4852Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderClose);
export default __webpack_public_path__ + "static/media/slider-close.28e60711b0fd78f22b805516abedafb0.svg";
export { ForwardRef as ReactComponent };